export const DEFAULTS = {
  MARGIN: 2,
  PADDING: 3,
} as const
